<template>
  <div id="abnrmDetc" class="wrap talk" style="background-color: white; height: 100vmax;">
    <header><h1><a class="logo"></a></h1></header>
    <div class="container">
      <main class="content">
        <h2 class="page_title">이상감지 알림</h2>
        <div v-if="!getSersNum || !hasData">
          이상감지 내용 없음
        </div>
        <table v-else>
          <tbody>
            <tr>
              <th colspan="2" style="font-size: 17px; text-align: center">
                {{ abnrmDectData.abnrmTypeCdNm }}
              </th>
            </tr>
            <tr>
              <th>
                감지시간
              </th>
              <td>
                {{ abnrmDectData.occDt }}
              </td>
            </tr>
            <tr v-if="abnrmDectData.fil13Title || abnrmDectData.fild1">
              <th>
                {{ abnrmDectData.fild1Title }}
              </th>
              <td>
                {{ abnrmDectData.fild1 }}
              </td>
            </tr>
            <tr v-if="abnrmDectData.fild2Title || abnrmDectData.fild2">
              <th>
                {{ abnrmDectData.fild2Title }}
              </th>
              <td>
                {{ abnrmDectData.fild2 }}
              </td>
            </tr>
            <tr v-if="abnrmDectData.fild3Title || abnrmDectData.fild3">
              <th>
                {{ abnrmDectData.fild3Title }}
              </th>
              <td>
                {{ abnrmDectData.fild3 }}
              </td>
            </tr>
            <tr v-if="abnrmDectData.fild4Title || abnrmDectData.fild4">
              <th>
                {{ abnrmDectData.fild4Title }}
              </th>
              <td>
                {{ abnrmDectData.fild4 }}
              </td>
            </tr>
          </tbody>
        </table>
      </main>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AbnrmDectNoti',
  components: {

  },
  data: () => ({
    abnrmDectData: {},
    hasData: false
  }),
  computed: {
    getSersNum () {
      return this.$route.query.sersNum
    }
  },
  created () {
    this.init()
  },
  mounted () {

  },
  watch: {

  },
  methods: {
    async init () {
      const sersNum = this.getSersNum
      if (!sersNum) {
        return
      }
      const res = await this.$http.get(`/api/appmgmt/public/abnrmDect/${sersNum}`)

      if (res) {
        const { data: { result } } = res

        if (result) {
          this.abnrmDectData = result
          this.hasData = true
        }
      }
    }
  }
}
</script>

<style>
#abnrmDetc .content {
  padding-left: 15px;
  padding-right: 15px;
}
#abnrmDetc .page_title {
  text-align: center;
  padding: 10px;
  margin-top: 10px;
}
#abnrmDetc table {
  width: 100%;
  margin-top: 15px;
  padding: 5px;
  border: 1px solid #0ac3bc;
}
#abnrmDetc table tr,
#abnrmDetc table th,
#abnrmDetc table td {
  padding: 15px 10px;
  border: 1px solid #0ac3bc;
}
#abnrmDetc table th {
  width: 30%;
  background-color: #f8f8f8;
  text-align: left;
}
</style>



// WEBPACK FOOTER //
// src/views/appmgmt/abnrm/index.vue